import { Injectable } from "@angular/core";
import { Observable, catchError, map, retry } from "rxjs";

//models
import { environment } from "src/environments/environment";

//services
import { ApiEnum, HttpDataService } from "./http-data.service";
import { AdminViewModel } from "../models/centros/admin.model";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: "root",
})
export class AdminService {
    constructor(private readonly httpDataService: HttpDataService, private readonly http: HttpClient) { }

    getAdminById(adminId: number) {
        return this.httpDataService
            .get$<AdminViewModel>(
                ApiEnum.API_ROOT,
                `${environment.endpoint.admin.getAdminById  }/${  adminId}`
            )
            .pipe(
                map((admin) => {
                    return admin;
                }),
                retry(3),
                catchError(this.httpDataService.handleError<AdminViewModel>('getAdminById'))
            );
    }

    updateAdmin(admin: AdminViewModel) {
        return this.httpDataService.put$<AdminViewModel>(ApiEnum.API_ROOT, environment.endpoint.admin.updateAdmin, admin)
            .pipe(
                map((admin) => {
                    return admin;
                }),
                retry(3),
                catchError(this.httpDataService.handleError<AdminViewModel>('updateAdmin'))
            );
    }

    exportResumenToExcel(userId: number): Observable<Blob> {
        return this.httpDataService.getFile$<Blob>(ApiEnum.API_ROOT, `${environment.endpoint.admin.exportToExcel  }?userId=${  userId}`)
            .pipe(
                retry(3),
                catchError(this.httpDataService.handleError<Blob>('exportResumenToExcel'))
            );
    }
}